"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = void 0;
// Used only when there is no micro/nano second precision
var ms = {};
var now = function () {
    var _a;
    if (typeof performance !== "undefined" &&
        typeof performance.now === "function") {
        return performance.now();
    }
    if (typeof process !== "undefined" &&
        typeof ((_a = process.hrtime) === null || _a === void 0 ? void 0 : _a.bigint) === "function") {
        return Number(process.hrtime.bigint());
    }
    if (typeof process !== "undefined" && typeof process.hrtime === "function") {
        var time = process.hrtime();
        return time[0] * 1e3 + time[1] / 1e6;
    }
    if (typeof Date && typeof Date.now === "function") {
        // In order to avoid collision between events we simulate a
        // microsecond behaviour
        var time = Date.now();
        if (!ms[time]) {
            ms[time] = 0;
            return time;
        }
        else {
            ms[time] += 1;
            return time + ms[time] / 1e3;
        }
    }
    else {
        throw new Error("No time API found");
    }
};
exports.now = now;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL25vdy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx5REFBeUQ7QUFDekQsSUFBTSxFQUFFLEdBQTRCLEVBQUUsQ0FBQztBQUVoQyxJQUFNLEdBQUcsR0FBRzs7SUFDakIsSUFDRSxPQUFPLFdBQVcsS0FBSyxXQUFXO1FBQ2xDLE9BQU8sV0FBVyxDQUFDLEdBQUcsS0FBSyxVQUFVLEVBQ3JDO1FBQ0EsT0FBTyxXQUFXLENBQUMsR0FBRyxFQUFFLENBQUM7S0FDMUI7SUFFRCxJQUNFLE9BQU8sT0FBTyxLQUFLLFdBQVc7UUFDOUIsT0FBTyxDQUFBLE1BQUEsT0FBTyxDQUFDLE1BQU0sMENBQUUsTUFBTSxDQUFBLEtBQUssVUFBVSxFQUM1QztRQUNBLE9BQU8sTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQztLQUN4QztJQUVELElBQUksT0FBTyxPQUFPLEtBQUssV0FBVyxJQUFJLE9BQU8sT0FBTyxDQUFDLE1BQU0sS0FBSyxVQUFVLEVBQUU7UUFDMUUsSUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQzlCLE9BQU8sSUFBSSxDQUFDLENBQUMsQ0FBQyxHQUFHLEdBQUcsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDO0tBQ3RDO0lBRUQsSUFBSSxPQUFPLElBQUksSUFBSSxPQUFPLElBQUksQ0FBQyxHQUFHLEtBQUssVUFBVSxFQUFFO1FBQ2pELDJEQUEyRDtRQUMzRCx3QkFBd0I7UUFDeEIsSUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDO1FBQ3hCLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDYixFQUFFLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQ2IsT0FBTyxJQUFJLENBQUM7U0FDYjthQUFNO1lBQ0wsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNkLE9BQU8sSUFBSSxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsR0FBRyxHQUFHLENBQUM7U0FDOUI7S0FDRjtTQUFNO1FBQ0wsTUFBTSxJQUFJLEtBQUssQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDO0tBQ3RDO0FBQ0gsQ0FBQyxDQUFDO0FBbENXLFFBQUEsR0FBRyxPQWtDZCJ9